import { FC } from 'react';
import styles from './AddingDocument.module.scss';
import { WhiteBlock } from 'components/WhiteBlock';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';

export const AddingDocument: FC<{ setShowModalAddingDocument: (e: boolean) => void }> = ({
  setShowModalAddingDocument,
}) => {
  const handleAddDocument = () => {
    setShowModalAddingDocument(true);
  };
  return (
    <WhiteBlock>
      <div className={styles.root}>
        <Title title={'Добавить документ'} />
        <Button theme='filed' onClick={handleAddDocument}>
          Добавить
        </Button>
      </div>
    </WhiteBlock>
  );
};
